/* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';

import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  makeStyles,
  TextField,
} from '@material-ui/core';

import MarketTable from '../MarketTable';

import {
  ButtonWithLoading,
  Spinner,
} from '../../../../components';

const useStyles = makeStyles({
  action: {
    alignSelf: 'center',
    marginTop: 0,
  },
});

const AuctionTable = ({
  data: marketData,
  isLoading,
  isSaving,
  onAddData,
  onDeleteData,
  onUpdateData,
  title,
  type,
}) => {

  const classes = useStyles();

  const columns = [
    {
      title: 'Year',
      field: 'year',
    },
    {
      title: 'New Zealand Bloodstock',
      field: 'nzb',
      type: 'currency',
      align: 'left',
    },
    {
      title: 'Magic Million(AUS)',
      field: 'mm',
      type: 'currency',
      align: 'left',
    },
    {
      title: 'Inglis(AUS)',
      field: 'ing',
      type: 'currency',
      align: 'left',
    },
  ];

  const [ newData, setNewData ] = useState({
    year: parseInt(new Date().getFullYear()),
    type: type,
    data: {
      nzb: 0,
      mm: 0,
      ing: 0,
    }
  });

  const handleFieldChange = (name, value) => {
    if (name === 'year') {
      setNewData({
        ...newData,
        year: parseInt(value) || 0,
      });
    } else {
      setNewData({
        ...newData,
        data: {
          ...newData.data,
          [name]: parseFloat(value) || 0,
        }
      })
    }
  }

  const handleClick = () => onAddData(newData);

  return (
    <>
      <Card>
        <CardHeader
          classes={{
            action: classes.action,
          }}
          title={title}
        />
        <Divider />
        {isLoading ?
          <Spinner /> :
          <CardContent style={{ padding: 0, paddingBottom: 0 }}>

            {/* Add data panel */}
            <div style={{ padding: 16 }}>
              <Grid
                container
                spacing={4}
              >
                <Grid
                  item
                  xs={6}
                  md={2}
                >
                  <TextField
                    disabled={isSaving}
                    fullWidth
                    label="Year"
                    name="year"
                    onChange={(event) => handleFieldChange('year', event.target.value)}
                    type="number"
                    value={newData.year}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={2}
                >
                  <TextField
                    disabled={isSaving}
                    fullWidth
                    label="New Zealand Bloodstock"
                    name="nzb"
                    onChange={(event) => handleFieldChange('nzb', event.target.value)}
                    type="number"
                    value={newData.data.nzb}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={2}
                >
                  <TextField
                    disabled={isSaving}
                    fullWidth
                    label="Magic Million(AUS)"
                    name="mm"
                    onChange={(event) => handleFieldChange('mm', event.target.value)}
                    type="number"
                    value={newData.data.mm}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={2}
                >
                  <TextField
                    disabled={isSaving}
                    fullWidth
                    label="Inglis(AUS)"
                    name="ing"
                    onChange={(event) => handleFieldChange('ing', event.target.value)}
                    type="number"
                    value={newData.data.ing}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  md={2}
                >
                  <ButtonWithLoading
                    color="primary"
                    defaultLabel="Add Data"
                    disabled={isSaving}
                    isLoading={isSaving}
                    loadingLabel="Adding..."
                    onClick={handleClick}
                    variant="contained"
                  />
                </Grid>
              </Grid>
            </div>

            <Divider />

            {/* Table */}
            <MarketTable
              columns={columns}
              data={marketData}
              onDeleteData={onDeleteData}
              onUpdateData={onUpdateData}
            />

          </CardContent>
        }
      </Card>
    </>
  );
}

export default AuctionTable;
